(function (root) {
  'use strict';

  // Presentation only. Targets must already be calculated by their data source.
  function Timeline(duration) {
    this.duration = duration || 760;
    this.hasTarget = false;
    this.current = 0;
    this.target = 0;
    this.running = false;
  }
  Timeline.prototype.sample = function (now) {
    if (!this.running) return this.current;
    var progress = Math.min(1, Math.max(0, (now - this.startedAt) / this.duration));
    if (progress === 1) {
      this.running = false;
      this.current = this.target;
    } else {
      this.current = this.from + (this.target - this.from) * (1 - Math.pow(1 - progress, 3));
    }
    return this.current;
  };
  Timeline.prototype.update = function (target, now, animate) {
    if (!Number.isFinite(target)) return false;
    if (this.hasTarget && Object.is(target, this.target)) {
      if (!animate) this.finish();
      return false;
    }
    var from = this.hasTarget ? this.sample(now) : 0;
    this.hasTarget = true;
    this.from = from;
    this.current = from;
    this.target = target;
    this.startedAt = now;
    this.running = !!animate && from !== target;
    if (!this.running) this.current = target;
    return true;
  };
  Timeline.prototype.finish = function () {
    this.running = false;
    this.current = this.target;
    return this.current;
  };
  function formatNumber(value, decimals, fractional) {
    if (!fractional) value = value < 0 ? Math.ceil(value) : Math.floor(value);
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value);
  }

  var records = new Map();
  var elements = new WeakMap();
  var frame = null;
  var motionQuery = root.matchMedia ? root.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var doc = root.document;
  var observer = doc && root.IntersectionObserver ? new root.IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var record = elements.get(entry.target);
      if (!record || record.element !== entry.target) return;
      if (entry.isIntersecting) present(record);
      else if (record.timeline.running) {
        record.timeline.finish();
        paint(record, record.timeline.current);
      }
    });
  }, { threshold: 0.01 }) : null;

  function effectsAllowed() {
    return !motionQuery.matches && !(doc && doc.body && doc.body.classList.contains('effects-off')) && (!root.GabineteUX || root.GabineteUX.effectsEnabled());
  }
  function visible(element) {
    if (!element || !element.isConnected || doc.hidden) return false;
    var box = element.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < root.innerHeight && box.right > 0 && box.left < root.innerWidth;
  }
  function paint(record, value) {
    if (!record.element || !record.element.isConnected) return;
    record.element.textContent = record.timeline.hasTarget && !record.timeline.running
      ? record.finalText
      : formatNumber(value, record.decimals, record.fractional);
  }
  function requestTick() {
    if (frame !== null || !root.requestAnimationFrame) return;
    frame = root.requestAnimationFrame(tick);
  }
  function tick(now) {
    frame = null;
    var remaining = false;
    records.forEach(function (record) {
      if (!record.timeline.running) return;
      if (!visible(record.element) || !effectsAllowed()) record.timeline.finish();
      else record.timeline.sample(now);
      paint(record, record.timeline.current);
      remaining = remaining || record.timeline.running;
    });
    if (remaining) requestTick();
  }
  function present(record) {
    if (!visible(record.element)) return;
    var safeAnimation = effectsAllowed() && Math.abs(record.value) <= Number.MAX_SAFE_INTEGER;
    record.timeline.update(record.value, root.performance.now(), safeAnimation);
    paint(record, record.timeline.sample(root.performance.now()));
    if (record.timeline.running) requestTick();
  }
  function bind(container, scope) {
    if (!doc || !container) return;
    records.forEach(function (record) {
      if (record.element && !record.element.isConnected) {
        if (observer) observer.unobserve(record.element);
        record.element = null;
      }
    });
    container.querySelectorAll('[data-count-key][data-count-value]').forEach(function (element) {
      var raw = element.getAttribute('data-count-value');
      var value = raw === null || raw.trim() === '' ? NaN : Number(raw);
      var decimals = Number(element.getAttribute('data-count-decimals') || 0);
      var fractional = element.getAttribute('data-count-fractional') === 'true';
      // Invalid/loading targets are not converted into zero or silently rounded.
      if (!Number.isFinite(value) || !Number.isInteger(decimals) || decimals < 0 || decimals > 20 || (!fractional && !Number.isInteger(value))) return;
      var key = String(scope || '') + ':' + element.getAttribute('data-count-key');
      var record = records.get(key);
      if (!record) {
        record = { timeline: new Timeline(), width: 0 };
        records.set(key, record);
      }
      var previousBinding = elements.get(element);
      if (previousBinding && previousBinding !== record) {
        previousBinding.timeline.finish();
        previousBinding.element = null;
        if (observer) observer.unobserve(element);
        elements.delete(element);
      }
      if (record.element && record.element !== element && observer) observer.unobserve(record.element);
      record.element = element;
      record.value = value;
      record.decimals = decimals;
      record.fractional = fractional;
      record.finalText = element.getAttribute('data-count-final') || formatNumber(value, decimals, fractional);
      record.width = Math.max(record.width, record.finalText.length);
      element.style.minInlineSize = '0';
      element.style.inlineSize = record.width + 'ch';
      element.classList.add('gc-number');
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('aria-live', 'off');
      element.textContent = record.finalText;
      record.height = Math.max(record.height || 0, element.getBoundingClientRect().height);
      if (record.height) element.style.minBlockSize = record.height + 'px';
      // A role=img wrapper with its final label already provides the accessible value.
      if (!(element.parentElement && element.parentElement.getAttribute('role') === 'img' && element.parentElement.hasAttribute('aria-label'))) {
        var label = element.nextElementSibling;
        if (!label || !label.classList.contains('gc-number-final')) {
          label = doc.createElement('span');
          label.className = 'sr-only gc-number-final';
          element.insertAdjacentElement('afterend', label);
        }
        label.textContent = record.finalText;
      }
      elements.set(element, record);
      if (observer) observer.observe(element);
      if (!effectsAllowed()) {
        record.timeline.update(value, root.performance.now(), false);
        paint(record, value);
      } else if (visible(element)) present(record);
      else element.textContent = record.finalText;
    });
  }
  function settle() {
    records.forEach(function (record) {
      record.timeline.update(record.value, root.performance.now(), false);
      paint(record, record.value);
    });
    if (frame !== null && root.cancelAnimationFrame) root.cancelAnimationFrame(frame);
    frame = null;
  }
  function dispose(scope) {
    var prefix = String(scope || '') + ':';
    records.forEach(function (record, key) {
      if (!key.startsWith(prefix)) return;
      if (record.element) {
        if (observer) observer.unobserve(record.element);
        elements.delete(record.element);
      }
      record.timeline.finish();
      records.delete(key);
    });
  }
  if (doc) {
    doc.addEventListener('gc:effects', function () { if (!effectsAllowed()) settle(); });
    doc.addEventListener('visibilitychange', function () { if (doc.hidden) settle(); });
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', function () { if (motionQuery.matches) settle(); });
    if (!observer) root.addEventListener('scroll', function () { records.forEach(present); }, { passive: true });
  }
  root.GabineteNumbers = { bind: bind, settle: settle, dispose: dispose, Timeline: Timeline, formatNumber: formatNumber };
})(typeof window === 'undefined' ? globalThis : window);
